// Admin-editable message templates for the Retention Engine (K1-K4 email, M1-M5
// WhatsApp). Seeded with DRAFT copy (see migrations/20260821_retention_engine_p2.sql)
// — review and rewrite before relying on it for real member-facing messages.
// {{name}} / {{days_to_expiry}} / {{last_topic}} are filled in per-member by
// libs/retentionEngine.js; keep them if you edit the copy.
let churnMessageTemplatesSection = {
  name: "Template Pesan Retensi",
  slug: "churnMessageTemplates",
  visible: true,
  singularName: "Template Pesan",
  crud: true,
  endpoint: "/crud/churn_message_templates",
  updateLabel: "reason_label",
  filters: [],
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  add: false,
  update: true,
  edit: true,
  exportToCsv: false,
  fields: [
    {
      label: "Kode",
      name: "template_code",
      type: "text",
      visible: true,
      input: false,
    },
    {
      label: "Channel",
      name: "channel",
      type: "text",
      visible: true,
      input: false,
    },
    {
      label: "Sebab",
      name: "reason_label",
      type: "text",
      visible: true,
      input: false,
    },
    {
      label: "Isi Template",
      name: "body_template",
      type: "text",
      visible: true,
    },
  ],
};

export default [churnMessageTemplatesSection];
